/* Company Confidential, Copyright (c) 2021 Signant Health, Ltd. All Rights Reserved. */

import React from 'react';
import { Typography } from '@material-ui/core';
import InfoIcon from '@material-ui/icons/Info';

export default function Info({ text }) {
  return (
    <div className="row info-container">
      <InfoIcon className="info-icon" fontSize="small" />
      <Typography>{text}</Typography>
    </div>
  );
}
